import { render, staticRenderFns } from "./EditPollModal.vue?vue&type=template&id=e6072e22&scoped=true&"
import script from "./EditPollModal.vue?vue&type=script&lang=js&"
export * from "./EditPollModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6072e22",
  null
  
)

export default component.exports